import { useMemo, useCallback } from "react"

import { useSelector } from "react-redux"

import { addReaction, removeReaction } from "@middlewares/backendMiddleware"
import { selectTeeupReactionsBySuggestionId } from "@selectors/teeups"

import { REACTION_TYPE } from "../../../constants/reactions"

import { useTeeUpPage } from "./index"

export const VOTE_OPTIONS = {
  downVote: "downVote",
  upVote: "upVote",
}

const useReactions = suggestionId => {
  const { user } = useTeeUpPage()
  const reactions = useSelector(
    selectTeeupReactionsBySuggestionId(suggestionId)
  )

  const upVote = useMemo(
    () =>
      reactions.find(reaction => reaction.reactionId === REACTION_TYPE.UPVOTE),
    [reactions]
  )
  const downVote = useMemo(
    () =>
      reactions.find(
        reaction => reaction.reactionId === REACTION_TYPE.DOWNVOTE
      ),
    [reactions]
  )

  const userVote = useMemo(() => {
    if (upVote?.reactedBy.find(userId => userId === user.id)) {
      return VOTE_OPTIONS.upVote
    }

    if (downVote?.reactedBy?.find(userId => userId === user.id)) {
      return VOTE_OPTIONS.downVote
    }

    return null
  }, [user, upVote, downVote])

  // BUG-020: tapping the same reaction a 2nd time removes it (toggle off); tapping the other one
  // switches the vote. The reducer already swaps an opposite vote, so we only special-case the
  // remove when the user already holds this vote.
  const onUpVote = useCallback(() => {
    if (userVote === VOTE_OPTIONS.upVote) {
      removeReaction({ reactionId: REACTION_TYPE.UPVOTE, suggestionId })
    } else {
      addReaction({ reactionId: REACTION_TYPE.UPVOTE, suggestionId })
    }
  }, [suggestionId, userVote])

  const onDownVote = useCallback(() => {
    if (userVote === VOTE_OPTIONS.downVote) {
      removeReaction({ reactionId: REACTION_TYPE.DOWNVOTE, suggestionId })
    } else {
      addReaction({ reactionId: REACTION_TYPE.DOWNVOTE, suggestionId })
    }
  }, [suggestionId, userVote])

  return { reactions, upVote, downVote, userVote, onDownVote, onUpVote }
}

export default useReactions
